import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Build a fully qualified media URL from a backend-returned path.
 * The backend serves files under "/api/files/...". We normalize legacy paths
 * that omit the "/api" prefix (some old client uploads stored them that way),
 * and prepend BACKEND_URL. A query-param token is appended so <img>/<a> tags
 * can authenticate without needing an Authorization header.
 */
export function mediaUrl(path) {
  if (!path) return path;
  if (/^https?:\/\//i.test(path)) return path;
  // Normalize "/files/xxx" → "/api/files/xxx" (legacy chat uploads)
  let normalized = path;
  if (normalized.startsWith('/files/')) normalized = '/api' + normalized;
  const token = localStorage.getItem('gtc_token') || '';
  const sep = normalized.includes('?') ? '&' : '?';
  return `${BACKEND_URL}${normalized}${sep}auth=${token}`;
}

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('gtc_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem('gtc_token');
      if (window.location.pathname !== '/login') window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;

export function getWsUrl() {
  const token = localStorage.getItem('gtc_token');
  const url = new URL(BACKEND_URL);
  const proto = url.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${url.host}/api/ws?token=${token}`;
}
